import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useRouter from 'use-react-router';
import {
  ButtonColor,
  PrimaryButton,
} from '../../../../common/buttons/PrimaryButton/PrimaryButton';
import { ErrorReportingUtils } from '@mm/plugins';
import {
  PathGraphContext,
  useNewGraphInstance,
} from '../../../../common/widgets/common/PathGraph/PathGraph';
import { useWidgetCRUDActions } from '@mm/state/actions/WidgetCRUDActions';
import { activeFacebookPageSelector } from '@mm/state/selectors/facebookPageSelector';
import { welcomePageSelector } from '@mm/state/selectors/onboardingSelectors';
import { widgetsByDialogueSelector } from '@mm/state/selectors/widgetSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import { StartBotsDialogueEditor } from '../../startBotPromoters/common/StartBotsDialogueEditor/StartBotsDialogueEditor';
import './FacebookPageWelcomerNew.pcss';
import { DialoguePreview } from '../../../../modules/DailoguePreview/DialoguePreview';

export const FacebookPageWelcomerNew = () => {
  const widgetCRUDActions = useWidgetCRUDActions();
  const activeFacebookPage = useSelector((state: StoreState) =>
    activeFacebookPageSelector(state),
  );
  const session = useSelector((state: StoreState) => state.session.session);
  const { match } = useRouter<{ chatbotId: string }>();

  const chatbotId = Number(match.params.chatbotId);

  const welcomePage = useSelector((state: StoreState) =>
    welcomePageSelector(state),
  );
  const widgets = useSelector((state: StoreState) =>
    welcomePage
      ? widgetsByDialogueSelector(welcomePage.id, state.widget.entities)
      : [],
  );

  useEffect(() => {
    if (welcomePage) {
      widgetCRUDActions.retrieveAll(welcomePage.id);
    } else {
      ErrorReportingUtils.reportError('Welcome Dialogue Missing', {
        extraData: {
          chatbotId,
          activeFacebookPageId: activeFacebookPage
            ? activeFacebookPage.id
            : undefined,
        },
      });
    }
  }, []);

  const onClickPreview = () => {
    if (activeFacebookPage && welcomePage) {
      window.open(
        `http://m.me/${activeFacebookPage.remoteId}?ref=${welcomePage.searchToken}_${session.searchToken}`,
      );
    }
  };

  const renderTestButton = () => (
    <PrimaryButton
      color={ButtonColor.secondaryBlue}
      className="facebook-page-welcomer-new__preview-button"
      onClick={onClickPreview}
    >
      Test my bot
    </PrimaryButton>
  );

  const pathGraph = useNewGraphInstance(welcomePage?.id);

  if (welcomePage) {
    return (
      <div className="facebook-page-welcomer-new">
        <div className="facebook-page-welcomer-new__body">
          <div className="facebook-page-welcomer-new__start-bot-section">
            <div className="facebook-page-welcomer-new__start-bot-wrapper">
              <PathGraphContext.Provider value={pathGraph}>
                <StartBotsDialogueEditor
                  widgets={widgets}
                  dialogueId={welcomePage.id}
                  chatbotId={chatbotId}
                  restrictToChannels={['facebook']}
                  platforms={['facebook']}
                />
              </PathGraphContext.Provider>
            </div>

            <div className="facebook-page-welcomer-new__dialogue-buttons">
              {renderTestButton()}
            </div>
          </div>

          <div className="facebook-page-welcomer-new__preview-section">
            <DialoguePreview
              dialogueId={welcomePage.id}
              style={{ top: -20, marginTop: 20 }}
              sticky
            />
          </div>
        </div>
      </div>
    );
  }

  return null;
};
